import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/increaseATBButtonOnPdp/show/showSelector';

const showIncreaseATBButtonOnPdpSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showIncreaseATBButtonOnPdpSelector };
